const zhHome = {
  'hero.badge': '🔥 今日TOP1爆料',
  'hero.title.line1': '91在线吃瓜网',
  'hero.title.line2': '黑料爆料入口',
  'hero.title.line3': '免费视频线路',
  'hero.desc': '聚焦网红明星塌房现场、聊天记录泄露、反差视频，每日猛料不停更。全网最速最全的吃瓜基地，带你第一时间看遍娱乐圈最真最炸的猛料。',
  'hero.btn1': '立即开瓜',
  'hero.btn2': '下载吃瓜APP',
  'trending.badge': '今日必看',
  'trending.title': '网红塌房现场 · 聊天记录泄露 · 反差视频',
  'categoryNav.badge': '频道导航',
  'categoryNav.title': '全网黑料 一站追踪',
  'categoryNav.subtitle': '四大频道覆盖全网瓜源，你想看的都在这里',
  'subscribe.title': '不想错过<span class="italic font-light text-foreground-400">任何猛料</span>？',
  'subscribe.titlePlain': '不想错过任何猛料？',
  'subscribe.btn': '下载吃瓜APP',
};

export default zhHome;